import { createNode, PlainDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDateTime } from '../../utils/temporal';

export const DateTimeNode = createNode({
    id: 'DateTime',
    name: 'DateTime',
    description: 'Creates a DateTime value from date and time components',
    aiDescription:
        'Takes number inputs on "Year", "Month", "Day", "Hour", "Minute", and optionally "Second" and "Millisecond" ports, and outputs a DateTime on the "DateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Year: { kind: 'number' },
        Month: { kind: 'number' },
        Day: { kind: 'number' },
        Hour: { kind: 'number' },
        Minute: { kind: 'number' },
        Second: { kind: 'number' },
        Millisecond: { kind: 'number' },
    },
    optionalInPorts: ['Second', 'Millisecond'],
    outPorts: {
        DateTime: PlainDateTimeDataType,
    },
    execute: function (input) {
        const dateTime = Temporal.PlainDateTime.from({
            year: input.inPorts.Year,
            month: Math.max(1, input.inPorts.Month),
            day: Math.max(1, input.inPorts.Day),
            hour: input.inPorts.Hour,
            minute: input.inPorts.Minute,
            second: input.inPorts.Second ?? 0,
            millisecond: input.inPorts.Millisecond ?? 0,
        });
        return { output: { DateTime: fromPlainDateTime(dateTime) } };
    },
});
